export const footer = {
  "description": "The property exchange platform between Airbnb owners. Travel for free anywhere in the world.",
  "company": "Company",
  "about": "About",
  "howItWorks": "How it works",
  "blog": "Blog",
  "careers": "Careers",
  "support": "Support",
  "help": "Help Center",
  "contact": "Contact",
  "terms": "Terms of Use",
  "privacy": "Privacy",
  "community": "Community",
  "members": "Members",
  "destinations": "Destinations",
  "events": "Events",
  "newsletter": "Newsletter",
  "newsletterText": "Receive our latest offers and news",
  "emailPlaceholder": "Your email",
  "newsletterSuccess": "Subscription successful!",
  "newsletterError": "An error occurred.",
  "newsletterInvalid": "Invalid email.",
  "subscribe": "Subscribe",
  "rights": "All rights reserved",
  "madeWith": "Made with",
  "by": "by the DONKEY TRAVEL team"
};
